import React from 'react';
import useReveal from '../hooks/useReveal';
import PageBanner from '../Components/PageBanner';
import GallerySection from '../Components/GallerySection';

const Gallery = () => {
    useReveal();

    return (
        <div>
            <PageBanner
                title="Gallery"
                text="Fabrication, glazing and finished facade work."
                image="/projects/11/1.jpeg"
            />
            <GallerySection />
        </div>
    );
};

export default Gallery;
